import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Video from '../components/Video.vue'

const Poverty = {
  // make sure to add a prop named exactly like the route param
  props: ['id'],
  template: '<div>Scenario {{ id }}</div>'
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect:'/poverty/1'
  },
  {
    path: '/:indicator/:id',
    name: 'Video',
    component: Video
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass : 'active'
})

export default router
